import { Component, OnInit, ViewChild, Directive } from '@angular/core';
import { ClienteLogin, ClienteXCiudad } from "../../login/cliente_login";
import { correctHeight, detectBody } from "../../../app.helpers";
import { SessionStorageService } from "ngx-webstorage/dist/services";
import { HandleError } from "../../../components/common/utils/handleError.component";
import { Router } from '@angular/router';
import { SessionTokenService } from "../../../components/common/utils/sessionToken.service";
import { ModalComponent } from "ng2-bs3-modal/ng2-bs3-modal";
import { MovimientosService } from "./movimientos.service";
import { MovimientosConsulta, Movimiento, MovimientosEntity,MovimientosDescripEntity } from "../entities/movimientos_entity";
import { UtilService } from "../../../components/common/utils/util.service";

const swal = require("sweetalert2");

declare var jQuery: any;
@Component({
    selector: 'movimientos',
    providers: [],
    templateUrl: 'movimientos.template.html'
})

export class MovimientosComponent implements OnInit {
    usuario: ClienteLogin;
    public showLoader: string;
    usuarioEmpresa: ClienteXCiudad;
    movimientosConsulta: MovimientosConsulta;
    segmento: number;
    resumenMovimientos: MovimientosEntity[];
    detalleMovimiento: MovimientosDescripEntity[];
    filterQuery: string;
    filterQuery2: string;
    filterQuery3: string;
    tipoMov: string[];
    estados: string[];
    detallesmov: string;
    constructor(private router: Router, private movimientosService: MovimientosService, private sesionStorageService: SessionStorageService, private handleError: HandleError,
        private sessionTokenService: SessionTokenService, public utilsService: UtilService) { }
        @ViewChild('DetalleMovimiento')
    modal: ModalComponent;
    
    
        ngOnInit() {
        this.showLoader = "sk-loading";
        this.detalleMovimiento = [];
        /*correctHeight();
        detectBody();*/
        this.usuario = jQuery.parseJSON(this.sesionStorageService.retrieve("usuario"));
        if (this.usuario == null) {
            let error = { "status": 998, "message": "Acceso denegado" };
            this.handleError.redirectUrl(error)
        } else {
            let bandera = this.sessionTokenService.useJwtHelper();
            if (!bandera) {
                this.movimientosConsulta = new MovimientosConsulta();
                this.resumenMovimientos = new Array<MovimientosEntity>();
                try {
                    this.usuarioEmpresa = JSON.parse(this.sesionStorageService.retrieve("usuarioEmpresa"));
                    this.movimientosConsulta.cliente = this.usuarioEmpresa;
                    this.cargaSegmento();
                    this.cargaTodo();
                } catch (e) {
                    this.usuarioEmpresa = this.sesionStorageService.retrieve("usuarioEmpresa");
                    this.movimientosConsulta.cliente = this.usuarioEmpresa;
                    this.cargaSegmento();
                    this.cargaTodo();
                }
                this.sesionStorageService.observe("usuarioEmpresa").subscribe(v => {
                    try {
                        this.usuarioEmpresa = JSON.parse(v);
                        this.movimientosConsulta.cliente = this.usuarioEmpresa;
                        this.cargaSegmento();
                        this.cargaTodo();
                    } catch (e) {
                        this.usuarioEmpresa = v;
                        this.movimientosConsulta.cliente = this.usuarioEmpresa;
                        this.cargaSegmento();
                        this.cargaTodo();
                    }
                });
            }
        }
    }
    cargaSegmento() {
        if (this.router.isActive('/patrimoniales/consultas/resumen-movimientos', false)) {
            this.movimientosConsulta.segmento = 1;
        }
        if (this.router.isActive('/pymes/consultas/resumen-movimientos', false)) {
            this.movimientosConsulta.segmento = 2;
        }
    }
    cargaTodo() {
        this.movimientosService
            .consultarMovimientos(this.movimientosConsulta)
            .subscribe(
            result => {
                this.resumenMovimientos = result;
                if(this.resumenMovimientos.length > 0){
                let tipoMov = result.map(function (obj) { return obj.TipoMovimiento; });
                this.tipoMov = tipoMov.filter(function (v, i) { return tipoMov.indexOf(v) == i; });
                let estados = result.map(function (obj) { return obj.Estado; });
                this.estados = estados.filter(function (v, i) { return estados.indexOf(v) == i; });
                }
                console.log(result);
                this.showLoader = "";
            },
            error => { this.handleError.redirectUrl(error); }
            )
    }
    modalOpen(e) {
        this.detallesmov="";
        
        this.movimientosService
            .ConsultarDetalleMovimiento(e)
            .subscribe(
            result => {
                this.detalleMovimiento = result;
                this.detalleMovimiento.forEach(element => {
                this.detallesmov=element.detalles;
                });
                this.modal.open();
                console.log(this.detalleMovimiento);
                this.showLoader = "";
            },
            error => { this.handleError.redirectUrl(error); }
            )
      

    }
    modalClose() {
        this.modal.close();
        //this.nuevoContratista = new ContratistaEntity();
       // this.bandera=0;
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/movimientos/movimientos.component.ts